import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";

export const Error500 = () => {
  return (
    <ErrorAlert
      title="Internal Server Error."
      errorCode={500}
      buttonTitle="Try Again"
      onClick={() => window.location.reload()}
    >
      <p>
        We apologize for any inconvenience.
        <br />
        For any inquiries, please contact us at syncbox@dorosee.kr.
      </p>
    </ErrorAlert>
  );
};
